import { trackCorrectedSearchTrigger } from "../../../../utils/SearchTrackingUtil";

import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import CustomerSettingsStore from "../../../../stores/settings/CustomerSettingsStore";

type Props = {
    amount: {
        final: number;
        suggestion: number;
    };
    query: {
        suggestion: string;
        original: string;
        final: string;
    };
};

class Suggestion extends React.Component<Props> {
    static propTypes = {
        amount: PropTypes.shape({
            final: PropTypes.number,
            suggestion: PropTypes.number
        }).isRequired,
        query: PropTypes.shape({
            suggestion: PropTypes.string.isRequired,
            original: PropTypes.string.isRequired,
            final: PropTypes.string.isRequired
        }).isRequired
    };

    handleClick = () => {
        trackCorrectedSearchTrigger(this.props.query.suggestion, CustomerSettingsStore.isFsdFilterActive());
    };

    render() {
        const query = this.props.query;
        const amount = this.props.amount;
        if (!query.suggestion || !amount.suggestion) {
            return <span className="no-suggestion" />;
        }
        const suggestion = query.suggestion.replace(/\\ /g, " ").trim();

        const target = "/search";
        const to = { pathname: target, query: { q: suggestion, s: true } };

        if (amount.final === 0) {
            return (
                <h4 className="ex-suggestion-subheadline">
                    <FormattedMessage id="EX_DID_YOU_MEAN" />
                    <Link className="ex-suggestion-no-result" to={to} onClick={this.handleClick}>
                        {suggestion}
                    </Link>
                    ?
                </h4>
            );
        } else if (query.final !== query.original && query.final === query.suggestion) {
            return (
                <h4 className="ex-suggestion-subheadline">
                    <FormattedMessage
                        id="EX_SEARCH_FOR_SUGGESTION"
                        values={{ query: query.original, suggestion: suggestion }}
                    />
                </h4>
            );
        } else {
            return (
                <h4 className="ex-suggestion-subheadline">
                    <FormattedMessage id="EX_DID_YOU_MEAN" />
                    <Link className="ex-suggestion-some-result" to={to} onClick={this.handleClick}>
                        {suggestion}
                    </Link>
                    ?
                </h4>
            );
        }
    }
}

export default Suggestion;
